module.exports = __webpack_public_path__ + "img/创新的可视化操控.ee22e1f6.png";